<template>
  <v-card-text class="py-6 px-6" v-if="software !== undefined">
    <p class="text-h6 font-weight-light white--text">
      <span class="dw_green--text mr-2">{{ software.mitre_id }}</span>
      {{ software.name }}
    </p>
    <p class="body-2 font-weight-light mb-0">
      {{ software.description }}
    </p>
  </v-card-text>
</template>

<script>
export default {
  name: 'softwareDetails',
  props: ['software']
};
</script>
